/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q6_QuestionInputs */

const en_home_faq_q6_question = /** @type {(inputs: Home_Faq_Q6_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What additional services are included with my policy?`)
};

const fr_home_faq_q6_question = /** @type {(inputs: Home_Faq_Q6_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels services supplémentaires sont inclus dans ma police ?`)
};

/**
* | output |
* | --- |
* | "What additional services are included with my policy?" |
*
* @param {Home_Faq_Q6_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q6_question = /** @type {((inputs?: Home_Faq_Q6_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q6_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q6_question(inputs)
	return fr_home_faq_q6_question(inputs)
});